import AppPeopleIndex from "./people.vue";
import AppPeopleList from "./list/list.vue";
import AppPeopleItem from "./item/item.vue";
import AppPeopleShow from "./item/show.vue";

const routes = [
  {
    path: "person",
    component: AppPeopleIndex,
    meta: {
      auth: {
        roles: "person.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "person.index",
        component: AppPeopleList,
        meta: {
          auth: {
            roles: "person.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "person.create",
        component: AppPeopleItem,
        meta: {
          auth: {
            roles: "person.create",
            redirect: { name: "person.index" }
          }
        }
      },
      {
        path: ":id/show",
        name: "person.show",
        component: AppPeopleShow,
        meta: {
          auth: {
            roles: "person.view",
            redirect: { name: "person.index" }
          }
        }
      },
      {
        path: ":id",
        name: "person.edit",
        component: AppPeopleItem,
        meta: {
          auth: {
            roles: "person.update",
            redirect: { name: "person.index" }
          }
        }
      }
    ]
  }
];

export default routes;
